
import IndexModelTable from '@/views/paginas/sigap/modelos/IndexModelTable.vue';
import CardRh from "@/components/cards/ManzaCard.vue";
import InstrutorService from "@/service/v1/sigap/InstrutorService";
import { Options } from "vue-class-component";
import SiteUtils from '@/assets/ts/aplicacao/site';
import KDataTable from "@/components/datatable/newdatatable.vue";
import $ from "jquery";
import { PerfilConfig } from "@/core/config/PerfisConfig";

@Options({
    name: "InstrutorIndex",
    components: { CardRh, KDataTable },
})
export default class InstrutorIndex extends IndexModelTable {
    public cpf: any = null;
    public turmaId: any = null;
    public pelotao = '';
    public disciplina = '';

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.Professor], this.perfis);
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    public limparFiltros() {
        this.pelotao = '';
        this.disciplina = '';
        this.refreshTable();
    }

    created() {
        this.service = new InstrutorService();
        this.cpf = this.currentUser.id;
        this.turmaId = this.$route.params.turmaId;
        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    cpf: this.cpf,
                    pelotao: this.pelotao,
                    disciplina: this.disciplina,
                    turmaId: this.turmaId,
                    search: d.search.value,
                };
                return dados;
            }
        };

        this.config.columns = [
            { data: 'disciplina.descricao', name: 'disciplina.descricao' },
            { data: 'pelotao', name: 'pelotao' },
            { data: 'turma.descricao', name: 'turma.descricao', searchable: false, class: 'desktop text-center' },
            { data: 'turma.status.nome', name: 'turma.status.nome', searchable: false, class: 'desktop text-center' },
            { data: 'turma.turmaInicio', name: 'turma.turmaInicio', searchable: false, class: 'desktop text-center' },
        ];
        this.config.columnDefs = [
            {
                targets: 3,
                render: (row) => {
                    return row.replaceAll('_', ' ');
                }
            },
            {
                targets: 4,
                render: (row) => {
                    return SiteUtils.formatData(row);
                }
            }
        ];
        if (this.hasPermissao) {
            this.config.columns.push({ data: 'id', name: 'id', orderable: false, searchable: false, class: 'text-center' });
            this.config.columnDefs.push(
                {
                    targets: 5,
                    render: (row, type, val) => {
                        let texto = '';
                        let buttom = '';
                        for (const key in val) {
                            buttom = buttom + ' data-' + key + '="' + val[key] + '"';
                        }
                        texto = texto + '<button class="btn btn-pmes-primary btn-sm" btn-notas ' + buttom + ' title="Avaliacoes"><i class="fa fa-file-signature "></i></button>';
                        texto = texto + '<button class="btn btn-pmes-warning btn-sm" btn-aulas ' + buttom + ' title="Aulas"><i class="fa fa-chalkboard"></i></button>';
                        return texto;
                    },
                }
            );
        }
    }

    public tableatualizada() {
        $('[btn-notas]').click((btn) => {
            const id = $(btn.currentTarget).data('id');
            this.$router.push({ name: 'instrutor_disciplina_notas', params: { instrutor: id } });
        });
        $('[btn-aulas]').click((btn) => {
            const id = $(btn.currentTarget).data('id');
            this.$router.push({ name: 'instrutor_disciplina_aulas', params: { instrutor: id } });
        });
        $('[btn-aulas-avulsa]').click((btn) => {
            const id = $(btn.currentTarget).data('id');
            const pelotao = $(btn.currentTarget).data('pelotao');
            const disciplina_id = $(btn.currentTarget).data('disciplinaId');
            this.$router.push({ name: 'instrutor_disciplina_aulas_avulsa', params: { instrutor: id, pelotao: pelotao, disciplina_id: disciplina_id } });
        });
    }
}
